import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import { fetchAdvertorial } from "@/lib/api";
import { ShareButtons } from "@/components/ShareButtons";
import { AdSlot } from "@/components/AdSlot";

export default function Advertorial() {
  const { slug } = useParams();
  const [ad, setAd] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setAd(null);
    setNotFound(false);
    fetchAdvertorial(slug).then(setAd).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="text-center py-32">
        <h1 className="font-anton text-5xl uppercase">404</h1>
        <Link to="/advertorials" className="inline-block mt-6 font-mono text-xs uppercase tracking-widest text-signal">
          ← Back to sponsored
        </Link>
      </div>
    );
  }
  if (!ad) return <p className="font-mono text-sm text-muted-foreground text-center py-32">Loading…</p>;

  return (
    <article>
      {/* Sponsored banner */}
      <div className="bg-white text-black">
        <div className="max-w-3xl mx-auto px-5 lg:px-10 py-2 flex items-center justify-between">
          <span className="font-mono text-[11px] uppercase tracking-[0.25em] font-bold">Paid Partnership</span>
          <span className="font-mono text-[11px] uppercase tracking-[0.25em]">{ad.brand}</span>
        </div>
      </div>

      <div className="relative grain h-[55vh] min-h-[380px] border-b border-white/10 overflow-hidden">
        <img src={ad.image} alt={ad.title} className="w-full h-full object-cover img-treatment" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
        <div className="absolute inset-0 max-w-4xl mx-auto px-5 lg:px-10 flex flex-col justify-end pb-12">
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-signal mb-4">
            Sponsored · {ad.category}
          </span>
          <h1 className="font-display font-semibold tracking-tighter leading-[0.95] text-4xl md:text-6xl" data-testid="advertorial-title">
            {ad.title}
          </h1>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-5 lg:px-10 py-14">
        <Link to="/advertorials" className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-muted-foreground hover:text-signal mb-10">
          <ArrowLeft className="w-4 h-4" /> All sponsored
        </Link>

        <p className="font-display text-2xl md:text-3xl leading-snug text-foreground/90 mb-8">{ad.dek}</p>

        <ShareButtons title={ad.title} className="mb-8" />

        <div className="space-y-6">
          {(ad.body || "").split("\n\n").map((p, i) => (
            <p key={i} className="text-foreground/85 text-lg leading-relaxed" data-testid={`advertorial-paragraph-${i}`}>
              {p}
            </p>
          ))}
        </div>

        {/* CTA */}
        <a
          href={ad.cta_url || "#"}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="advertorial-cta"
          className="inline-flex items-center gap-2 mt-10 bg-signal text-white font-mono text-xs uppercase tracking-widest px-7 py-4 hover:bg-signal-hover transition-colors"
        >
          {ad.cta_text || "Learn More"} <ArrowUpRight className="w-4 h-4" />
        </a>
        <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground mt-6">
          This is a paid advertisement created in partnership with {ad.brand}.
        </p>

        <AdSlot variant="leaderboard" slot={process.env.REACT_APP_ADSENSE_SLOT_ADVERTORIAL} className="mt-12" />
      </div>
    </article>
  );
}
